<template>
  <joy-page :joyPageStatus="joyPageStatus">
    <div class="setHeightFullGrey paddingbottom50">
      <van-field
        v-model="listData.name"
        clearable
        label="姓名"
        placeholder="请输入姓名"
        disabled
      />
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>性别</span></div>
        <div class="van-cell__value flexRow">
          <div class="marginRightXm">
            <van-switch
              size="20px"
              v-model="switchSex"
              disabled
            />
          </div>
          <div style="margin: 0 15rpx;line-height: 30px;height: 100%;">{{switchSex?'男':'女'}}</div>
        </div>
      </div>
      <van-field
        v-model="listData.mobile"
        clearable
        label="手机"
        type="number"
        placeholder="请输入手机号码"
        disabled
      />
      <van-field
        v-model="listData.idnumber"
        clearable
        label="身份证"
        placeholder="请输入身份证号码"
      />
      <van-field
        v-model="listData.passport"
        clearable
        label="护照"
        placeholder="请输入护照号码"
      />
      <div
        class="van-cell van-field"
        @click="showDate=true"
      >
        <div class="van-cell__title van-field__label"><span>生日</span></div>
        <div class="van-cell__value flexRow">
          <span style="color: #323233;">{{listData.birthday}}</span>
        </div>
      </div>
      <van-field
        v-model="listData.city2"
        clearable
        label="常在地址"
        placeholder="请输入常在地址"
      />

      <div
        class="van-cell van-field"
        @click="showCityPop=true"
      >
        <div class="van-cell__title van-field__label"><span>现居地址</span></div>
        <div class="van-cell__value flexRow">
          <span style="color: #323233;">{{listData.city}}</span>
        </div>
      </div>
      <van-field
        v-model="listData.college"
        clearable
        label="大学名称"
        placeholder="请输入大学名称"
      />
      <van-field
        v-model="listData.grade"
        clearable
        label="所在年级"
        placeholder="请输入所在年级"
      />
      <van-field
        v-model="listData.major"
        clearable
        label="所在专业"
        placeholder="请输入所在专业"
      />
      <van-field
        v-model="listData.speciality"
        type="textarea"
        clearable
        rows="2"
        autosize
        label="个人特长"
        placeholder="请输入个人特长"
      />
      <van-field
        v-model="listData.remark"
        type="textarea"
        clearable
        rows="4"
        autosize
        label="个人备注"
        placeholder="请输入个人备注"
      />
      <van-field
        v-model="listData.camera"
        clearable
        label="相机型号"
        placeholder="请输入相机型号"
      />

      <!-- <van-cell title="拍摄作品"></van-cell>
      <div
        class="paddingXm"
        style="background-color:#fff;"
      >
        <van-uploader
          :before-read="zuopin"
          v-model="zuopinList"
          :max-count="1"
        />
      </div> -->

    </div>

    <div class="fixBottom">
      <van-button
        @click="save"
        type="info"
        size="large"
      >保存</van-button>
    </div>
    <!-- 添加生日弹窗 -->
    <van-popup
      v-model="showDate"
      position="bottom"
    >
      <van-datetime-picker
        show-toolbar
        v-model="currentTime"
        type="date"
        :min-date="minDate"
        @confirm="confirmDate"
        @cancel="showDate=false"
      />
    </van-popup>
    <!-- 城市三级联动 -->
    <van-popup
      v-model="showCityPop"
      position="bottom"
    >
      <van-area
        :area-list="areaList"
        @confirm="confirmCity"
        :columns-num="3"
        title="选择城市"
      />
    </van-popup>
  </joy-page>
</template>

<script>
import addressList from '../../../common/area.js'
export default {
  created() {
    this.loadData()
  },
  data() {
    return {
      showCityPop: false,
      minDate: new Date(1950, 1, 1),
      currentTime: new Date(2010, 0, 1),
      showDate: false,
      joyPageStatus: '',
      listData: '',
      switchSex: false,
      areaList: addressList,
      zuopinList: [],
      idZuopin: '',
    }
  },
  methods: {
    zuopin(files) {
      const _this = this
      let reader = new FileReader()
      reader.readAsDataURL(files) // 这里是最关键的一步，转换就在这里
      reader.onloadend = function () {
        lrz(this.result, { quality: 0.5 })
          .then(function (rst) {
            _this.idZuopin = rst.base64
          })
          .catch(function (err) {
            console.log(err)
          })
      }
      return true
    },
    confirmCity(value) {
      let name = ''
      for (let i in value) {
        if (i < 2) {
          name += value[i].name + '-'
        } else {
          name += value[i].name
        }
      }
      this.showCityPop = false
      this.listData.city = name
    },
    save() {
      const that = this
      if (that.listData.city2 == '' || that.listData.city2 == null) {
        that.$dialog.alert({
          message: '常在地址不能为空',
        })
      } else if (that.listData.college == '' || that.listData.college == null) {
        that.$dialog.alert({
          message: '大学名称不能为空',
        })
      } else if (that.listData.grade == '' || that.listData.grade == null) {
        that.$dialog.alert({
          message: '所在年级不能为空',
        })
      } else if (
        that.listData.speciality == '' ||
        that.listData.speciality == null
      ) {
        that.$dialog.alert({
          message: '个人特长不能为空',
        })
      } else {
        let sex = that.switchSex ? '男' : '女'
        let query = {
          idnumber: that.listData.idnumber,
          passport: that.listData.passport,
          sex: sex,
          birthday: that.listData.birthday,
          city: that.listData.city,
          city2: that.listData.city2,
          college: that.listData.college,
          grade: that.listData.grade,
          major: that.listData.major,
          speciality: that.listData.speciality,
          remark: that.listData.remark,
          camera: that.listData.camera,
        }
        if (that.listData.idnumber) {
          try {
            that.$axios.post('user/update2', query).then((res) => {
              if (res.data.code == 200) {
                that.$toast.success('保存成功')
                setTimeout(function () {
                  that.$router.go(-1)
                }, 1000)
              } else {
                that.$toast.fail(res.data.msg)
              }
            })
          } catch (e) {
            if (this.$mConfig.debug) {
              console.log(e)
            }
          }
        } else {
          if (that.listData.passport) {
            try {
              that.$axios.post('user/update2', query).then((res) => {
                if (res.data.code == 200) {
                  that.$toast.success('保存成功')
                  setTimeout(function () {
                    that.$router.go(-1)
                  }, 1000)
                } else {
                  that.$toast.fail(res.data.msg)
                }
              })
            } catch (e) {
              if (this.$mConfig.debug) {
                console.log(e)
              }
            }
          } else {
            that.$toast.fail('身份证或护照不能为空')
          }
        }
      }
    },
    // 生日弹窗
    confirmDate(value) {
      let d = new Date(value)
      this.listData.birthday =
        d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
      this.showDate = false
    },
    loadData() {
      try {
        this.joyPageStatus = 'loading'
        this.$axios.get('user/info').then((res) => {
          this.joyPageStatus = 'success'
          if (res.data.code == 200) {
            this.listData = res.data.data
            this.zuopinList.push({ url: this.listData.pic })
            this.listData.sex == '男'
              ? (this.switchSex = true)
              : (this.switchSex = false)
            if (this.listData.idnumber == null) {
              this.listData.idnumber = ''
            }
            if (this.listData.passport == null) {
              this.listData.passport = ''
            }
          } else {
            this.$toast.fail(res.data.msg)
          }
        })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
  },
}
</script>

<style scoped="scoped">
</style>
